/**
 * Chevron Right Icon Component
 *
 * Right chevron icon with official toolkit sizes.
 *
 * @module @smoothie-framework/ui/icons/chevron-right-icon
 */
import { createIconNode } from '../create-icon';
const CHEVRON_RIGHT_ICON = Object.freeze({
    sm: {
        viewBox: '0 0 16 16',
        paths: [{ d: 'M6.5 4.5L9.5 8L6.5 11.5', stroke: 'currentColor', strokeWidth: '1px', strokeLinecap: 'round', strokeLinejoin: 'round' }],
    },
    md: {
        viewBox: '0 0 24 24',
        paths: [{ d: 'M9.5 6.5L14.5 12L9.5 17.5', stroke: 'currentColor', strokeWidth: '1px', strokeLinecap: 'round', strokeLinejoin: 'round' }],
    },
});
export function ChevronRightIcon(props) {
    return createIconNode(CHEVRON_RIGHT_ICON, props);
}
//# sourceMappingURL=chevron-right.js.map